import { Component, Input, OnChanges } from '@angular/core';
import { DocumentoGeneradoSolicitudDTO } from '../../services/radicacion-traslados-service/generacion-documentos-traslados.service';
import { EnlaceFirmaResponse } from '../../services/firma/firma.service';

export interface FilaResumenDocumentoGenerado {
  tipoDocumento: string;
  nombreDocumento: string;
}

@Component({
  selector: 'app-contracto-generado',
  templateUrl: './contracto-generado.component.html',
  styleUrls: ['./contracto-generado.component.css'],
})
export class ContractoGeneradoComponent implements OnChanges {
  @Input() solicitudNumero = '';
  @Input() documentos: DocumentoGeneradoSolicitudDTO[] = [];
  @Input() enlaceFirma: EnlaceFirmaResponse | null = null;
  @Input() errorEnlaceFirma: string | null = null;

  filasResumen: FilaResumenDocumentoGenerado[] = [];

  ngOnChanges(): void {
    this.filasResumen = (this.documentos ?? []).map((d) => ({
      tipoDocumento: String(d.tipoDocumento ?? '').trim() || '—',
      nombreDocumento: String(d.nombreDocumento ?? d.nombreClaveJasper ?? '—').trim() ||'—',
    }));
  }
}
